/* Oud Arabia — minimal vanilla JS. No jQuery, no dependencies. */
(function () {
  'use strict';

  /* ── Drawers (search modal, mobile menu, cart) ─────────────────── */
  function openDrawer(name) {
    var el = document.querySelector('[data-oud-drawer="' + name + '"]');
    if (!el) return;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    var focus = el.querySelector('[data-oud-autofocus]');
    if (focus) setTimeout(function () { focus.focus(); }, 30);
  }
  function closeDrawer(el) {
    el.hidden = true;
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-oud-open]');
    if (opener) { openDrawer(opener.getAttribute('data-oud-open')); return; }

    var closer = e.target.closest('[data-oud-close]');
    if (closer) { closeDrawer(closer.closest('[data-oud-drawer]')); return; }

    var overlay = e.target.closest('[data-oud-drawer]');
    if (overlay && !e.target.closest('[data-oud-panel]')) closeDrawer(overlay);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-oud-drawer]:not([hidden])').forEach(closeDrawer);
  });

  /* ── Header dropdown (hover open, matches original) ──────────────── */
  document.querySelectorAll('[data-oud-dropdown]').forEach(function (dd) {
    var panel = dd.querySelector('[data-oud-dropdown-panel]');
    var btn = dd.querySelector('button');
    if (!panel) return;
    dd.addEventListener('mouseenter', function () { panel.hidden = false; if (btn) btn.setAttribute('aria-expanded', 'true'); });
    dd.addEventListener('mouseleave', function () { panel.hidden = true; if (btn) btn.setAttribute('aria-expanded', 'false'); });
    if (btn) btn.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
      btn.setAttribute('aria-expanded', String(!panel.hidden));
    });
  });

  /* ── Hero slideshow crossfade ──────────────────────────────── */
  document.querySelectorAll('[data-oud-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-oud-hero-slide]');
    if (slides.length < 2) return;
    var i = 0;
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 5000;
    setInterval(function () {
      i = (i + 1) % slides.length;
      slides.forEach(function (s, j) { s.style.opacity = j === i ? '1' : '0'; });
    }, interval);
  });

  /* ── Product variant picker ────────────────────────────────── */
  (function () {
    var dataEl = document.querySelector('[data-oud-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-oud-option]')) return;
      var selected = [];
      document.querySelectorAll('[data-oud-option]:checked').forEach(function (input) {
        selected[parseInt(input.getAttribute('data-position'), 10) - 1] = input.value;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (!match) return;
      var idInput = document.querySelector('[data-oud-variant-id]');
      if (idInput) idInput.value = match.id;
      var btn = document.querySelector('#ProductForm [data-oud-add-to-cart]');
      if (btn) btn.disabled = !match.available;
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    });
  })();

  /* ── AJAX cart ─────────────────────────────────────────── */
  function refreshCart(openAfter) {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer-proxy' : '/?sections=cart-drawer-proxy')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-proxy'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-oud-cart-contents]');
        var target = document.querySelector('[data-oud-cart-contents]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        var badgeFresh = doc.querySelector('[data-oud-cart-badge-proxy]');
        document.querySelectorAll('[data-oud-cart-badge]').forEach(function (b) {
          if (!badgeFresh) return;
          var count = parseInt(badgeFresh.textContent, 10) || 0;
          b.textContent = count;
          b.hidden = count === 0;
        });
        if (openAfter) openDrawer('cart');
      })
      .catch(function () { if (openAfter) window.location.href = '/cart'; });
  }

  /* Intercept single-variant "Add to cart" forms for drawer add */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form.action || '').match(/\/cart\/add/)) return;
    var btn = form.querySelector('[data-oud-add-to-cart]');
    if (!btn) return; /* forms without the flag submit normally */
    e.preventDefault();
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        refreshCart(true);
        var flash = btn.getAttribute('data-oud-added-label');
        if (flash) {
          var orig = btn.textContent;
          btn.textContent = flash;
          btn.classList.add('is-added');
          setTimeout(function () { btn.textContent = orig; btn.classList.remove('is-added'); }, 1400);
        }
      })
      .catch(function () { form.submit(); })
      .finally(function () { btn.disabled = false; });
  });

  /* Quantity +/− inside the drawer */
  document.addEventListener('click', function (e) {
    var qbtn = e.target.closest('[data-oud-qty]');
    if (!qbtn) return;
    var key = qbtn.getAttribute('data-oud-qty');
    var qty = parseInt(qbtn.getAttribute('data-qty'), 10);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { refreshCart(false); });
  });

  /* Order note */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-oud-cart-note]')) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: e.target.value })
    });
  });
})();
